export default __webpack_public_path__ + "static/4-b07bcc994632839adaff56a67b143cf1.woff2";